// src/com/bulk_company/BulkCompanyDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// Bulk상품 취급업체 Dictionary
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    bulkCompanyId : {
		id: 'bulkCompanyId', label: 'bulkCompanyId',
		type: InputType.number, required: true, toAdd: false, toEdit: true,
		check: (value) => {return value >= 1 && value <= 99999999},
	}, // int(11)
    comName : {
		id: 'comName', label: 'Bulk 업체',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '50자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 1, 50)},
	}, // varchar(50)
    /* useYn : {
		id: 'useYn', label: 'useYn',
		type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    updatedDate : {
		id: 'updatedDate', label: 'updatedDate',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    updatedUser : {
		id: 'updatedUser', label: 'updatedUser',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	}, // varchar(40) */
    
};

/**
 * BULK_COMPANY React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2026-05-13 16:13:14 using DbdbTap
 * https://www.dbdbtap.com
 */
export const BulkCompanyDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: 'Bulk 상품 취급업체 등록 오류',
        Edit: 'Bulk 상품 취급업체 수정 오류',
        Remove: 'Bulk 상품 취급업체 삭제 오류',
        SetUsage: 'Bulk 상품 취급업체 사용여부 변경 오류',
        Get: 'Bulk 상품 취급업체 조회 오류',
    },
    tableProps: {
        tableId: 'bulkCompanyTable',
        uniqueKey: 'bulkCompanyId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'bulkCompanyId', label: Dict.bulkCompanyId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'comName', label: Dict.comName.label, width: 180, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: '사용여부', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            //{ id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'updatedDate', label: '등록일', width: 160, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'updatedUser', label: Dict.updatedUser.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
